import { render, staticRenderFns } from "./m2m_bc_drug.vue?vue&type=template&id=caba775c&"
import script from "./m2m_bc_drug.vue?vue&type=script&lang=js&"
export * from "./m2m_bc_drug.vue?vue&type=script&lang=js&"
import style0 from "./m2m_bc_drug.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports